module.exports = __webpack_public_path__ + "img/MDA.8cefd6df.svg";